<template>
  <v-container
    fluid
    tag="section"
  >
    <v-row justify="center">
      <v-col
        cols="12"
        md="12"
      >
        <material-card
          color="primary"
          :help="help"
          :icon="icon"
        >
          <template #title>
            {{ page_title }}
          </template>

          <validation-observer
            ref="form"
            v-slot="{ passes }"
          >
            <v-form
              @submit.prevent="passes(save)"
            >
              <v-container class="py-0">
                <!-- Editform -->
                <slot name="editform" />
                <v-row class="pa-3">
                  <question-btn
                    v-if="canDelete && !newItem"
                    color="delete"
                    simple-button
                    :title="$t('delete')"
                    question="global_delete_question"
                    @click="remove"
                  />
                  <v-spacer />
                  <v-btn
                    color="cancel"
                    min-width="90"
                    class="mx-1"
                    @click="escape"
                  >
                    {{ $t('cancel') }}
                  </v-btn>
                  <v-btn
                    v-shortkey.once="['f10']"
                    color="save"
                    dark
                    min-width="90"
                    type="submit"
                    @shortkey="passes(save)"
                  >
                    {{ $t('save') }}
                  </v-btn>
                </v-row>
              </v-container>
            </v-form>
          </validation-observer>
        </material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'CumulusEditForm',
    props: {
      icon: {
        type: String,
        default: '$edit',
      },
      title: {
        type: String,
        default: 'datas',
      },
      titleExt: {
        type: String,
        default: '',
      },
      canDelete: {
        type: Boolean,
        default: true,
      },
      newItem: {
        type: Boolean,
        default: true,
      },
      help: {
        type: String,
        default: '',
      },
    },
    computed: {
      page_title () {
        let result = this.$t(this.newItem ? 'insert' : 'edit', { type: this.$t(this.title) })
        if (this.titleExt !== '') {
          result += ' - ' + this.titleExt
        }
        return result
      },
    },
    methods: {
      save () {
        this.$emit('save')
      },
      remove () {
        this.$emit('remove')
      },
      escape () {
        this.$emit('escape')
      },
      setErrors (e) {
        this.$refs.form.setErrors(e)
        // this.$refs.form.setErrors(e.response.data.errors)
      },
    },
    beforeRouteEnter (to, from, next) {
      console.log('beforeRouteEnter in component')
    },
  }
</script>
